// extracted by mini-css-extract-plugin
export default {"box":"paymentCustomSelect_box__H4m0E","box__option":"paymentCustomSelect_box__option__xY0Mp"};